export default __webpack_public_path__ + "static/media/List.e07e1279.svg";